<template>
    <div>
        <h3 class="mt-3">Sales Channels</h3>

        <div class="row mt-5">
            <div class="col-sm-10 ml-4">


                <div class="form-group channelOptions">
                    <div class="full mb-3 pRelative mb-3" v-for="salesChannel in getSelectedEvent.channelCommissions">
                        <div class="d-flex align-items-center justify-content-between">

                            <div class="">
                                <div class="d-flex align-items-center">
                                    <checkbox v-model="salesChannel.isActive" @input="salesChannelStateChanged(salesChannel)" class="mt-1">
                                        {{salesChannel.channelName}}
                                    </checkbox>

                                    <div v-if="salesChannel.channelType == 50" class="ml-2">
                                        <v-select :options="agentsChannelOptions" :disabled="!salesChannel.isActive" v-model="selectedAgentsChannelOptions" @input="agentsChannelOptionsChanged($event, salesChannel)"></v-select>
                                    </div>

                                </div>

                                <div v-if="salesChannel.channelType == 50">

                                    <div class="d-flex flex-column pRelative ml-4" v-if="getSelectedEvent.salesPermissionsAgentsCustom">

                                        <agent-white-list class="mt-2" :allowedList="getSelectedEvent.salesPermissionsAgentsList" :blockedList="getSelectedEvent.salesBlockedAgentList" :startAllSelected="customAgentListSelectAll" @input="agentListChanged"></agent-white-list>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import AgentWhiteList from '../../../components/inventory/products/components/AgentWhiteList'
    export default {
        props: {
            validations: {
                type: Object
            }
        },
        data: function() {
            return {
                agentsChannelOptions: [
                    {
                        label: 'All Agents',
                        value: false
                    },
                    {
                        label: 'Agent Selection',
                        value: true
                    }
                ],
                selectedAgentsChannelOptions: {
                    label: 'All Agents',
                    value: false
                }
            }
        },
        created: function() {
            //if flag salesPermissionsAgentsCustom is not set, we set as false
            // if(this.getSelectedEvent.salesPermissionsAgentsCustom == undefined ){
            //     this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', false)
            // }

            if(this.getSelectedEvent.salesPermissionsAgentsList && this.getSelectedEvent.salesPermissionsAgentsList.length > 0){
                this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', true)
                this.selectedAgentsChannelOptions = this.agentsChannelOptions[1]
            } else {
                this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', false)
            }

        },
        computed: {
            ...mapGetters([
                'getSelectedEvent'
            ]),
            customAgentListSelectAll: function(){
                return false
            },
        },
        methods: {
            agentsChannelOptionsChanged: function($event, salesChannel) {
                // salesChannel.isActive = true
                this.getSelectedEvent.salesPermissionsAgentsCustom = $event.value
                if($event.value == false){
                    this.getSelectedEvent.salesPermissionsAgentsList = []
                    this.getSelectedEvent.salesBlockedAgentList = []
                }

            },
            salesChannelStateChanged: function (channel) {
                if(channel.channelType == 50 && channel.isActive == false){
                    this.selectedAgentsChannelOptions = this.agentsChannelOptions[0]
                }
            },
            commissionTypeChanged: function(salesChannel, target){
                let helper = target+'_helper_selected'
                let setTo = target
                salesChannel[setTo] = salesChannel[helper].id
            },
            agentListChanged: function(agentList) {
                if(!this.getSelectedEvent){
                    return false
                }

                this.$set(
                    this.getSelectedEvent,
                    'salesPermissionsAgentsList',
                    agentList.filter(agent => {
                        return agent.selected
                    })
                )

                this.$set(
                    this.getSelectedEvent,
                    'salesBlockedAgentList',
                    agentList.filter(agent => {
                        return !agent.selected
                    })
                )
            },
        },
        components: {
            vSelect: extendedVSelect,
            AgentWhiteList,
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaSalesPermissions.vue?4a5cf7c0